"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HodUserOnboardingRejectionInfo = exports.HodOnboardingRejectionReason = void 0;
const BaseUserOnboardingRejectionInfo_1 = require("../../common/domain/BaseUserOnboardingRejectionInfo");
var HodOnboardingRejectionReason;
(function (HodOnboardingRejectionReason) {
    HodOnboardingRejectionReason["ZONE_NOT_SUPPORTED_YET"] = "ZONE_NOT_SUPPORTED_YET";
    HodOnboardingRejectionReason["NOT_INTERESTED"] = "NOT_INTERESTED";
    HodOnboardingRejectionReason["FAKE_USER"] = "FAKE_USER";
    HodOnboardingRejectionReason["SUSPICIOUS_USER"] = "SUSPICIOUS_USER";
    HodOnboardingRejectionReason["DUPLICATE"] = "DUPLICATE";
    HodOnboardingRejectionReason["OTHER"] = "OTHER";
})(HodOnboardingRejectionReason = exports.HodOnboardingRejectionReason || (exports.HodOnboardingRejectionReason = {}));
class HodUserOnboardingRejectionInfo extends BaseUserOnboardingRejectionInfo_1.BaseUserOnboardingRejectionInfo {
}
exports.HodUserOnboardingRejectionInfo = HodUserOnboardingRejectionInfo;
//# sourceMappingURL=HodUserOnboardingRejectionInfo.js.map